import themeReducer from "./themeReducer";
import sidebarReducer from "./sidebarReducer";
import cryptoTableReducer from "./cryptoTableReducer";
import newOrderTableReducer from "./newOrderTableReducer";
import customizerReducer from "./customizerReducer";

import drawerReducer from "./drawerReducer";
import authReducer from "./authReducer";
import commonReducer from "./commonReducer";
import accountReducer from "./accountReducer";
import geoReducer from "./geoReducer";
import testsReducer from "./testsReducer";
import networkReducer from "./networkReducer";
import notificationReducer from "./notificationReducer";

export {
  themeReducer,
  sidebarReducer,
  cryptoTableReducer,
  newOrderTableReducer,
  customizerReducer,
  drawerReducer,
  authReducer,
  commonReducer,
  accountReducer,
  geoReducer,
  testsReducer,
  networkReducer,
  notificationReducer
};



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js